import { Box, CircularProgress } from '@mui/material'

const Loading = () => {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                color: 'white',
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000, // メインコンテンツより前面に表示
            }}
        >
            <CircularProgress size={150} color='inherit' /> {/* ローディングアイコン */}
        </Box>
    )
}

export default Loading;
